export default __webpack_public_path__ + "static/media/learose2-1024w.2d118137.webp";